import { action } from "mobx";
import { DashboardAddStore } from "./DashboardAddStore";
import { DashboardRemoveStore } from "./DashboardRemoveStore";
var addDashboard = action(function (opts) {
    DashboardAddStore.init(opts);
});
var removeDashboard = action(function (opts) {
    DashboardRemoveStore.init(opts);
});
export { addDashboard, removeDashboard };
